module.exports = __webpack_public_path__ + "static/media/Satoshi-Medium.3f3ea942.woff";